<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="container-fluid">
  <h6  class="manage-boder pt-2 font1 font-bold1"> <router-link class="decoration" to="/admin/overview"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Apartment List </h6>
 
  <h6 class="custom-maintitle "><b>Apartment List</b></h6>

<div style="padding-top: 0px; margin-bottom: -10px; padding-bottom: 0px; border-bottom: 0px;"  class="navbar ">
  
  <div style="margin-top:-20px;" class="d-flex " >
 
    <b-input-group size="sm" style="width: 225px;">
            <b-form-input id="filter-input" v-model="filter" type="search" placeholder="Search">
            </b-form-input>
            
    </b-input-group>
    
</div>
  


<div  style="margin-top:-20px; margin-right: -2px;" class="d-grid gap-2 d-md-flex justify-content-md-end">




</div>
</div>



<div class="card ">
<div class="card-body ">
 

  <b-table responsive style="font-size: small;"  class="table-striped table-hover "
      :items="apartments"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
      @filtered="onFiltered"
    >
   


      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>

      <template #cell(actions)="row">
      
        <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
          View
        </b-button> -->
        
        <button  style=" font-size: small;"
         @click="info(row.item.idCustomer)" class="mr-1 btn custom-btn btn-primary btn-sm mb-1">
          View
        </button>
       
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>

 <!-- model start -->
 <b-modal   :id="infoModal.id" :title="infoModal.content.C_code"  hide-footer >
<div class=" ">
<div class="card">
  <div class="card-body">

      <table style="font-size: small; " class="table  table-sm  ">
       
       <tbody >

         <tr >
           <td style="border: 0px;" ><b>Id </b></td>
          <td style="border: 0px;">{{ infoModal.content.idCustomer }}</td> 
         </tr>
         <tr>
           <td><b>Name of Homeowner </b></td>
          <td>{{ infoModal.content.C_name }}</td> 
         </tr>
         <tr>
           <td><b>Address Line 1 </b></td>
          <td>{{ infoModal.content.C_address_line1 }}</td> 
         </tr>
        
         <tr>
           <td><b>Address Line 2 </b></td>
          <td>{{ infoModal.content.C_address_line2 }}</td> 
         </tr>
         <tr>
           <td><b>Address Line 3 </b></td>
          <td>{{ infoModal.content.C_address_line3 }}</td> 
         </tr>
         <tr>
           <td><b>Apt Phone </b></td>
          <td>{{ infoModal.content.C_contact_tel1 }}</td> 
         </tr>
         <tr>
           <td><b>Service charge/<br> Sinking fund </b></td>
          <td>{{ infoModal.content.billing_type }}</td> 
         </tr>
         <tr>
           <td><b>Created Date </b></td>
          <td>{{ infoModal.content.C_created_date }}</td> 
         </tr>
        
          
       </tbody>


     </table>


<div style="border-bottom:0px"  class="navbar ">
  
  <div  class="d-flex " >
    <button  v-on:click="ViewLoad(infoModal.content.idCustomer)"   class=" btn custom-btn btn-primary btn-sm mb-1"> More</button>
  
    
</div>
  


<div   class="d-grid  d-md-flex justify-content-md-end">

  <button  class="btn custom-btn btn-primary btn-sm mb-1">Create CRM Notes</button>
  <button   class="btn custom-btn btn-primary btn-sm mb-1">Create Issue</button>




</div>
</div>





</div>
</div>
</div>  
      
    </b-modal>

    <!-- model end -->



    
      <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-5">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>

      

  
    
    

  

</div>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 20,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        apartments:[],
       
        fields: [
          { key: 'C_code', label: 'Apt No.', sortable: true, sortDirection: 'desc' },
          { key: 'C_name', label: 'Name of Homeowner', sortable: true,  },
          { key: 'tel', label: 'Homeowner Contact No.', sortable: true  },
          { key: 'tenant_name', label: 'Tenant', sortable: true  },
          { key: '', label: 'Tenant Contact No.', sortable: true  },
          { key: 'C_contact_tel1', label: 'Apt Phone', sortable: true  },
          { key: 'billing_type', label: 'Service charge/ Sinking fund', sortable: true  },
          { key: 'C_occupants', label: 'Number of Occupants', sortable: true ,  },
          
          { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],
      
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },

        
      }

    },
    computed: {
     
    },
    mounted(){
     
      
  this.loadApartment();


    },
methods : {

  ViewLoad(id) {
    
    this.$router.push('/aparment/view?id='+id);
  },

  async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.customer
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },

  serchCustom(id) {

this.filterOn = id;
  },

  onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  
  async loadApartment() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/mcustomer/index',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
        this.apartments = data.customer;
       this.totalRows = this.apartments.length;
      
    } catch (error) {
      console.log(error.response);
    }
  },
   

       


 
  


 


},

    components :{
        ContentFooter,
        TopNavbar
    },
  }

</script>
<style >

</style>